<template>
  <v-data-table
      :headers="tabla.headers"
      :items="tabla.items"
      :options.sync="tabla.options"
      :server-items-length="tabla.count"
      :fixed-header="true"
      class="elevation-3"
      calculate-widths
      :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
      :no-data-text="$t('No hay datos')"
      :no-results-text="$t('No hay datos')"
  >
    <template v-slot:item.delete="{ item }">
      <v-btn x-small fab icon @click="delete_documento(item)">
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>
    </template>

    <!-- Columna fecha -->
    <template v-slot:item.created="{ item }">
      <span>{{ item.created | moment('DD/MM/YYYY HH:mm') }}</span>
    </template>

    <!-- Tipo -->
    <template v-slot:item.tipo="{ item }">
      <div>
        <v-tooltip  min-width="500" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-if="item.tipo === 'pdf'" color="green" v-bind="attrs" v-on="on">
              mdi-file-pdf-box
            </v-icon>
            <v-icon v-else-if="item.tipo === 'png' || item.tipo === 'jpg' || item.tipo === 'jpeg'" color="red" v-bind="attrs" v-on="on">
              mdi-image
            </v-icon>
            <v-icon v-else-if="item.tipo === 'doc' || item.tipo === 'docx'" color="blue" v-bind="attrs" v-on="on">
              mdi-file-word-box
            </v-icon>
            <v-icon v-else-if="item.tipo === 'xls' || item.tipo === 'xlsx'" color="orange" v-bind="attrs" v-on="on">
              mdi-file-excel-box
            </v-icon>
            <v-icon v-else-if="item.tipo === 'ppt' || item.tipo === 'pptx'" color="yellow" v-bind="attrs" v-on="on">
              mdi-file-powerpoint-box
            </v-icon>
          </template>
          <iframe style="width: 100%; min-height: 830px;" :src="`${item.file_absolute_path}?x-token=${token}`" frameborder="0"></iframe>
        </v-tooltip>
      </div>
    </template>

    <template v-slot:item.open="{ item }">
      <v-btn small fab icon @click="open_documento(item)">
        <v-icon color="primary">mdi-download</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>


<script>
import useTable from "@/composables/useTable"
import store from "@/store";

export default {
  name: 'TablaDocumentos',
  props: {
    url: {
      type: String,
      default: "cliente/get_documentos",
      required: false
    },
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    },
  },
  setup(props, {root}){

    const token = store.getters['auth/access_token']

    const { tabla, get_items } = useTable(props["url"])

    const get_documentos = async () => get_items(props['selected_filters'])
    get_documentos()

    tabla.value.headers = [
      { text: '', value: 'delete', class: "primary white--text", sortable: false, align: 'left', width: "60px"},
      { text: root.$t('Fecha'), value: 'created', class: "primary white--text pa-0"},
      { text: root.$t('Título'), value: 'titulo', class: "primary white--text pa-0"},
      { text: root.$t('Tipo'), value: 'tipo', class: "primary white--text"},
      { text: '', value: 'open', class: "primary white--text", sortable: false, align: 'right', width: "60px"},
    ]

    const open_documento = (documento) => {
      window.open(`${documento.file_absolute_path}?x-token=${token}`, '_blank')
    }

    const delete_documento = async (documento) => {

      const resp = await root.$confirm(root.$t('¿Eliminar definitivamente?').toString())
      if (resp) {
        try {
          await root.$store.dispatch('cliente/delete_documento', documento)
          root.$snotify.success(
            root.$t("Acción realizada con éxito"),
            root.$t('Atención {0}', [root.$store.getters['auth/user'].first_name])
          )
          await get_documentos()
        } catch (err) {
          root.$snotify.error(
            root.$t("Ha ocurrido un error"),
            root.$t('Atención {0}', [root.$store.getters['auth/user'].first_name])
          )
        }
      }

    }

    return {
      tabla,
      get_documentos,
      open_documento,
      delete_documento,
      token
    }
  }
}
</script>
